// File: frontend/src/services/entryLocationService.ts

import { apiClient } from "./apiClient";

/**
 * Where a single entry lives, as resolved by the backend.
 *
 * `path` is the canonical topic page path with no query string and no
 * fragment; `page` is the 1-based page number the entry sits on FOR THIS
 * VIEWER — page size is a per-account preference and the rookie filter changes
 * how many entries precede it, so the same entry is on different pages for
 * different readers. That is exactly why the page number is not baked into the
 * shared link and is asked for at open time instead.
 */
export interface EntryLocation {
  entryId: number;
  targetType: "MATCH" | "PERSON" | "CLUB" | "TEAM" | "CUSTOM_TOPIC";
  targetId: number;
  path: string;
  page: number;
  size: number;
  /**
   * How many visible entries come before this one in the topic's default
   * (oldest-first) order. The focused view uses it directly for the
   * "{n} entry daha" bar above the entry; the bar below shows
   * totalItems - precedingCount - 1.
   */
  precedingCount: number;
  totalItems: number;
}

/**
 * Resolves "/entry/{id}" into the topic page, page number and anchor.
 *
 * Throws when the entry does not exist or has been deleted — the permalink
 * page turns that into a "bu tanım bulunamadı" message rather than dumping the
 * reader on an unrelated topic.
 */
export const fetchEntryLocation = async (
  entryId: number,
  size: number,
  showRookieEntries: boolean
): Promise<EntryLocation> => {
  const params = new URLSearchParams({
    size: String(size),
    showRookieEntries: String(showRookieEntries),
  });
  return apiClient.get<EntryLocation>(`/api/entries/${entryId}/location?${params.toString()}`);
};